import config from './config';
import { IConfig } from './IConfig';
import { featureToggle } from './featureToggle';

export type { IConfig };
export { featureToggle };
export default config;
